module.exports = __webpack_public_path__ + "img/nuts.97156af5.svg";